import { IconAlertTriangle } from "@tabler/icons-react";
import { Alert } from "@/components/ui";

export function ZipReuploadWarning() {
  return (
    <Alert variant="warning" icon={<IconAlertTriangle size={16} stroke={1.7} />}>
      Esta solicitud ya tiene CFDIs cargados desde un ZIP previo. Si subes otro se <strong>resetearán</strong> los datos generales, proveedores, prorrateos y documentos vinculados.
    </Alert>
  );
}
